import React from "react";
import "./Overall.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class Overall extends React.Component {
    render() {
        return(
<div>
    <Nav/>
    <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov">Eco-Innovation</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall">Overall Introduction</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Overall Introduction</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold', color: 'green'}}>Key industry clusters</p>
        <p className="text-justify">The Good Morning Bamboo Eco-city is been named the world's first Bamboo and Lime Bricks Eco-City. It attracts industries that include agro-processing Industry, green industry, electronics, infocomm, AI, Robotics & Nanotechnology industry, tourism & creative industry, and dry port and logistics zone. The Eco-City will provide a platform for companies in these industries to collaborate and test-bed their new technologies and solutions.


</p>
<p style={{ fontWeight: 'bold', color: 'green'}}>Parks</p>
        <p className="text-justify">Good Morning Bamboo Agro-Forestry and Investment Services will develop the Eco-Business Park, Eco-Innovation Park and a wide range of commercial amenities to cater to different business needs. All our buildings will be IFC-EDGE Certified - will be built in compliance with green building evaluation standard, which creates a better environment for both production and working as well as save on water and electricity consumption, thus reducing operational costs.</p>
       </div>
      
     </div>
   </div>
</div>
        )
    }
}
export default withRouter(Overall);